var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SearchListTypes"},[_c('SearchRefinementList',{staticClass:"SearchListTypes_items",attrs:{"attribute-name":_vm.name,"operator":"or","sortBy":['name:asc'],"listType":"buttons"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }